import { queryDepositStatus } from "@/api/wallet";
import { useStore } from "vuex";
import { showSuccess, showError } from "@/utils/toast";

// 轮询定时器
let pollingTimer: number | null = null;

// 已处理的订单缓存，防止同一订单重复处理
const processedOrders = new Set<string>();

/**
 * 开始轮询充值状态
 * @param orderId 订单ID
 * @param userInfo 用户信息
 * @param store Vuex store实例
 */
export const startDepositPolling = async (
  orderId: string,
  userInfo: any,
  store: any
) => {
  console.log("开始调整充值轮询", orderId, userInfo);
  // 清除可能存在的旧定时器
  if (pollingTimer) {
    clearInterval(pollingTimer);
    pollingTimer = null;
  }
  if (!orderId) {
    return;
  }
  let attempts = 0;
  const initialMaxAttempts = 60; // 前60次轮询，使用5秒间隔
  let currentInterval = 5000; // 初始间隔5秒
  const extendedInterval = 180000; // 3分钟间隔

  const pollDeposit = async () => {
    try {
      attempts++;
      const response = await queryDepositStatus(orderId);
      if (response.status === "completed") {
        // 检查订单是否已经处理过
        if (processedOrders.has(orderId)) {
          return;
        }

        // 标记订单为已处理
        processedOrders.add(orderId);

        // 充值成功
        clearInterval(pollingTimer!);
        pollingTimer = null;
        // 删除localStorage中的orderId
        localStorage.removeItem("orderId");
        await store.dispatch("auth/fetchUserInfo"); // 更新用户信息
        showSuccess("Depósito realizado com sucesso!");
      } else if (
        ["failed", "expired", "canceled", "paid", "new"].includes(
          response.status
        )
      ) {
        // 充值失败
        clearInterval(pollingTimer!);
        pollingTimer = null;
        // 删除localStorage中的orderId
        localStorage.removeItem("orderId");
        // 清理已处理订单记录
        processedOrders.delete(orderId);

        // 根据不同状态显示具体的错误信息
        let errorMessage = "Falha ao processar o depósito";
        if (response.status === "expired") {
          errorMessage = "Depósito expirado. Por favor, tente novamente.";
        } else if (response.status === "failed") {
          errorMessage =
            "Falha no processamento do depósito. Verifique os dados e tente novamente.";
        }
        showError(errorMessage);
      } else if (attempts === initialMaxAttempts) {
        // 达到60次后，切换到3分钟间隔
        clearInterval(pollingTimer!);
        currentInterval = extendedInterval;
        console.log(
          `切换到长轮询模式：每${extendedInterval / 1000 / 60}分钟轮询一次`
        );
        pollingTimer = window.setInterval(pollDeposit, currentInterval);
      }
    } catch (error) {
      console.error("Failed to query deposit status:", error);
    }
  };

  // 开始轮询，初始使用5秒间隔
  pollingTimer = window.setInterval(pollDeposit, currentInterval);
};

/**
 * 停止轮询
 */
export const stopDepositPolling = () => {
  if (pollingTimer) {
    clearInterval(pollingTimer);
    pollingTimer = null;
  }
};

/**
 * 检查并处理未完成的订单
 * @param userInfo 用户信息
 * @param store Vuex store实例
 */
export const checkPendingDeposit = async (userInfo: any, store: any) => {
  const orderId = localStorage.getItem("orderId");
  if (orderId && userInfo) {
    console.log("Found pending deposit order:", orderId);
    // 开始轮询未完成的订单状态
    await startDepositPolling(orderId, userInfo, store);
  }
};
